import { render, staticRenderFns } from "./SupportTicketPreviousReply.vue?vue&type=template&id=0a182883&scoped=true&"
import script from "./SupportTicketPreviousReply.vue?vue&type=script&lang=js&"
export * from "./SupportTicketPreviousReply.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketPreviousReply.vue?vue&type=style&index=0&id=0a182883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a182883",
  null
  
)

export default component.exports